import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import SignupStep1 from "../components/SignUpStep1";
import SignupStep2 from "../components/SignupStep2";
import SignupStep3 from "../components/SignupStep3";
import SignupStep4 from "../components/SignupStep4";
import SignupStep5 from "../components/SignupStep5";
import SignupStep6 from "../components/SignupStep6";
import SignupStep7 from "../components/SignupStep7";

/**
 * Enterprise-grade Join component
 * - Stops at Step 7
 * - Modular registry-based step rendering
 * - Blocking validation per step
 * - Ready for future expansion (AddSchool, optional steps)
 * - Redirects to /feed after Step 7
 */
export default function Join() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});

  // Modular step registry
  const stepRegistry = [
    { id: 1, component: SignupStep1 },
    { id: 2, component: SignupStep2 },
    { id: 3, component: SignupStep3 },
    { id: 4, component: SignupStep4 },
    { id: 5, component: SignupStep5 },
    { id: 6, component: SignupStep6 },
    { id: 7, component: SignupStep7 },
  ];

  // Centralized next handler
  const handleNext = useCallback(
    (data) => {
      setFormData((prev) => ({ ...prev, ...data }));

      // Blocking validation check (example: require essential fields)
      const currentStep = stepRegistry.find((s) => s.id === step);
      if (currentStep?.component?.validate && !currentStep.component.validate(data)) {
        console.warn("Step validation failed. Cannot proceed.");
        return;
      }

      if (step < stepRegistry.length) {
        setStep(step + 1);
      } else {
        // Step 7 completed → navigate to feed
        navigate("/feed");
      }

      // Analytics hook example (track step completion)
      // trackEvent("signup_step_complete", { step, formData });
    },
    [step, stepRegistry, navigate]
  );

  // Centralized back handler
  const handleBack = useCallback(() => {
    if (step > 1) setStep(step - 1);
  }, [step]);

  // Render current step dynamically
  const CurrentStepComponent = stepRegistry.find((s) => s.id === step)?.component;

  return CurrentStepComponent ? (
    <CurrentStepComponent
      formData={formData}
      onNext={handleNext}
      onBack={handleBack}
    />
  ) : null;
}
